const features = [
  {
    icon: 'ri-database-2-line',
    title: '海量资源库',
    desc: '收录超过十万部电影、电视剧、综艺和动漫作品，涵盖全球热门内容与经典佳作，类型丰富应有尽有。',
  },
  {
    icon: 'ri-4k-line',
    title: '高清流畅播放',
    desc: '全站支持1080P及以上高清画质，多线服务器智能调度，加载速度快、播放不缓冲，观影体验极致顺滑。',
  },
  {
    icon: 'ri-user-unfollow-line',
    title: '完全免费无广告',
    desc: '无需注册、无需付费、无弹窗广告干扰，打开网页即可直接观看，让每一位用户平等享受影视乐趣。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-8 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 text-xs font-medium text-accent-400 bg-accent-500/10 rounded-full mb-3">
            平台优势
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            为什么选择天堂影院
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {features.map((feat, idx) => (
            <div
              key={idx}
              className="group relative p-6 md:p-8 rounded-lg bg-background-100 border border-background-200/60 hover:border-accent-500/20 transition-all duration-300"
            >
              <div className="w-12 h-12 rounded-md bg-accent-500/10 flex items-center justify-center mb-5 group-hover:bg-accent-500/20 transition-colors">
                <i className={`${feat.icon} text-xl text-accent-400`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-3">
                {feat.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {feat.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}